export enum ESearchItemType {
  RecentlySearched = 'RecentlySearched',
  AutocompleteSuggestion = 'AutocompleteSuggestion',
}

export enum EMoveDirection {
  Up = 'up',
  Down = 'down',
}

export enum EAccessibility {
  Normal = 'normal',
  AccessDenied = 'accessDenied',
  NotFound = 'notFound',
  OtherError = 'otherError',
}
